module.exports = __webpack_public_path__ + "img/join-header.15b5eb76.png";